import WebView from './WebView';

export default class TypeformView extends WebView {

    

}
